import { getStoredValue, persistentAtom } from './persistence';
import { atom } from 'nanostores';

export type ViewType = 'operator' | 'officer' | 'audit';

/**
 * Current view - UI state, does not persist
 */
const initialView: ViewType =
  typeof document !== 'undefined' &&
  (document.body.classList.contains('officer-only') ||
    getStoredValue('connected-server', null) !== null)
    ? 'officer'
    : 'operator';

export const $view = atom<ViewType>(initialView);

export const $dismissedWizard = persistentAtom<boolean>(
  'dismissed-wizard',
  false,
);

/**
 * Check if this is the first time opening the app
 * by checking if there's any persisted data
 */
function isFirstTime(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  // Can't open if in officer-only mode
  if (document.body.classList.contains('officer-only')) {
    return false;
  }

  return !$dismissedWizard.get();
}

/**
 * New Logbook Wizard visibility
 *
 * Shows automatically on first use
 */
export const $showWizard = atom<boolean>(isFirstTime());

export function openNewLogbookWizard() {
  $showWizard.set(true);
}

export function closeNewLogbookWizard() {
  $showWizard.set(false);
  $dismissedWizard.set(true);
}

export function setConnectionReadonlyMode(enabled: boolean) {
  if (enabled) {
    $view.set('officer');
  }
}
